import { DocumentNode } from 'graphql';

export interface StoreItem {
  id: string;
  name: string;
}

export interface StoreItemInput {
  entity: StoreItemEntity;
  input?: object;
  mutation: DocumentNode;
  isInput: boolean;
}

export interface StoreItemDeleteInput {
  entity: StoreItemEntity;
  id: string;
  input: object;
  isInput?: boolean;
  mutation: DocumentNode;
}

export interface StoreItemFiltering {
  filtering?: object;
  isNotFiltering?: boolean;
  query?: DocumentNode;
  entity?: StoreItemEntity;
  paginationEntity?: StoreItemEntity;
}

export enum StoreItemEntity {
  pagination = 'pagination',
  notification = 'notification',
  inAppNotification = 'inAppNotification',
  institution = 'institution',
  designation = 'designation',
  itemType = 'itemType',
  itemCategory = 'itemCategory',
  itemStrength = 'itemStrength',
  itemDosage = 'itemDosage',
  item = 'item',
  financialYear = 'financialYear',
  reviewCriteria = 'reviewCriteria',


  // GISP
  department = 'department',

}
